@import (reference) '../../../constants/spacing.module.less';

.attribute-row-toggle {
  display: flex;
  align-items: center;
  gap: @space-4;
  padding: @space-0 @space-16 @space-8;
}

.caret {
  align-items: center;

  > svg {
    width: 8px;
    height: 12px;
  }
}

.items-table-sub-row-dangerous-goods {
  text-align: left;
  line-height: 18px;
  overflow-wrap: anywhere;
}

.dangerous-goods-row {
  display: inline-flex;
  flex-wrap: wrap;
  padding-top: @space-8;
  padding-bottom: @space-8;
  margin-top: @space-4;
  background-color: var(--new-grey-100);
  font-size: 0.75rem;
}

.dangerous-goods-row-title {
  font-weight: 700;
  color: var(--grey-900);
  line-height: 16px;
  width: 140px;
  padding-left: @space-16;
  padding-top: @space-4;
}

.dangerous-goods-row-value {
  width: 140px;
  padding-left: @space-16;
  padding-bottom: @space-4;
}
